export interface ImageDimensions {
  readonly width: number;
  readonly height: number;
}

/**
 * A wipe comparison is truthful only when both captures describe the same
 * viewport shape. Allow a one-percent measurement difference for encoders
 * that add or remove a border pixel, but reject portrait-vs-landscape pairs.
 */
export function matchingImageProportions(
  left: ImageDimensions,
  right: ImageDimensions,
  boundaryPixelTolerance = 1,
): boolean {
  if (left.width <= 0 || left.height <= 0 || right.width <= 0 || right.height <= 0) return false;
  const crossProductDifference = Math.abs(left.width * right.height - right.width * left.height);
  const onePixelScale = Math.max(left.width, left.height, right.width, right.height);
  return crossProductDifference <= Math.max(0, boundaryPixelTolerance) * onePixelScale;
}
